import { ParsedUrlQuery } from 'querystring';
import { stringify } from 'query-string';
import { SortingMethod } from '@wix/ambassador-explore-catalog/types';
import _ from 'lodash';
import { NextRouter } from 'next/router';
import { Category, Service } from '@wix/ambassador-category-services/types';
import { IParams } from '@common/types';

export const generatePathWithQueryParams = (qs: object) => {
  return !_.isEmpty(qs) ? `?${stringify(qs)}` : '';
};

export const QUERY_PARAMS = {
  lang: 'lang',
  min: 'min',
  max: 'max',
  serviceIds: 'serviceIds',
  sort: 'sort',
  location: 'location',
  currency: 'currency',
};

type QueryParams = {
  lang?: string;
  min?: number;
  max?: number;
  serviceIds?: string;
  sort?: SortingMethod;
  page?: number;
  location?: string;
  currency?: string;
};

export type ClearAll = {
  services: boolean;
  language: boolean;
  location: boolean;
  all: boolean;
};

export const updateQueryParams = (
  newValues: QueryParams,
  router: NextRouter,
  clearWasClicked?: ClearAll,
) => {
  const { query } = router;

  if (clearWasClicked?.all) {
    const { currency } = query;
    const clearedParams = { ...newValues };
    if (currency) {
      _.set(clearedParams, 'currency', currency);
    }
    return generatePathWithQueryParams(clearedParams);
  }

  if (clearWasClicked?.services && !newValues.serviceIds) {
    newValues.serviceIds = '';
  }

  if (clearWasClicked?.language && !newValues.lang) {
    newValues.lang = '';
  }

  if (clearWasClicked?.location && !newValues.location) {
    newValues.location = '';
  }

  const valuesToKeepTheSame = _.difference(
    _.keys(QUERY_PARAMS),
    _.keys(newValues),
  );

  const updatedParams: QueryParams = {};

  _.forEach(valuesToKeepTheSame, (key: string) => {
    const value = query[key];
    if (value) {
      _.set(updatedParams, key, value);
    }
  });

  _.forEach(_.keys(newValues), (key: string) => {
    const value = _.get(newValues, key);
    if (value) {
      _.set(updatedParams, key, value);
    }
  });

  return generatePathWithQueryParams(updatedParams);
};

export function getServicesFiltersFromUrl(
  query: IParams | ParsedUrlQuery,
  allServicesWithHierarchy: Array<Category>,
  service?: any,
  category?: Category,
) {
  let serviceIds = query.serviceIds as string;
  if (service) {
    serviceIds = service.displayKey!;
  } else if (category) {
    serviceIds = _.map(category.services, (s) => s.displayKey!).join(',');
  }

  let _selectedServices: Array<string> = [];
  if (_.size(serviceIds) > 0) {
    _selectedServices = serviceIds!.split(',');
  }

  const servicesList = _.flatMap(allServicesWithHierarchy, (category) => {
    return category.services!;
  });

  const _services: Array<Service> = _.filter(servicesList, (item) =>
    _selectedServices.includes(item!.displayKey!),
  );

  return _services;
}

export const convertServicesToIds = (_services: Array<Service>) => {
  return _.map(_services, (service) => service.id) as Array<string>;
};
